import QnArticleCard from "@elements/Card/QuickNews/QnArticleCard";
import QnPhotoGalleryCard from "@elements/Card/QuickNews/QnPhotoGalleryCard";
import QnTmPicksCard from "@elements/Card/QuickNews/QnTmPicksCard";
import { ProcessedArticleData } from "@transformer/useOsResponse";
import { QNCardType } from "@typings/QuickNews";
import { ReactElement, useMemo } from "react";

type QuickNewsCardProps = {
  item: ProcessedArticleData;
  index: number;
  typeIndex: number;
  setActiveTab: (tab: QNCardType) => void;
  onPrev: () => void;
  onNext: () => void;
};

export function QuickNewsCard({
  item,
  index,
  typeIndex,
  setActiveTab,
  onPrev,
  onNext,
}: QuickNewsCardProps): ReactElement {
  const isActive = typeIndex === index;

  const cardProps = useMemo(
    () => ({
      item,
      index,
      typeIndex,
      isActive,
      setActiveTab,
      onPrev,
      onNext,
    }),
    [item, index, typeIndex, isActive, setActiveTab, onPrev, onNext],
  );

  const renderedCard = useMemo(() => {
    switch (item.sectionName) {
      case "tm-picks":
        return <QnTmPicksCard {...cardProps} />;
      case "photo-gallery":
        return <QnPhotoGalleryCard {...cardProps} />;
      default:
        return <QnArticleCard {...cardProps} />;
    }
  }, [cardProps, item.sectionName]);

  return (
    <div className="w-full h-full m-auto overflow-hidden">{renderedCard}</div>
  );
}
